import {
  FormControlLabel,
  Radio,
  RadioGroup,
  FormControl,
} from "@material-ui/core";
import React, { useState, useEffect, Fragment } from "react";
import { Container, Modal, Col, Image } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { Row } from "reactstrap";
import { SET_VENDOR_ORDERING_CART_DATA } from "../../../../store/types";
import { connect } from "react-redux";
import Slider from "@material-ui/core/Slider";
import { ITEMTYPEVEG } from "../../../../enums/OrderEnums";
import { DEFAULT_ITEM_IMAGE } from "../../../../enums/GlobalEnums";

const CustomizationTwo = (props) => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(props.open);
  const [value, setValue] = useState(0);
  const [customizationData, setCustomizationData] = useState([]);

  const [cartData, setCardData] = useState({});

  // const onCloseModal = () => {
  //   setOpen(false);
  //   props.setOpen(false);
  // };

  const onChangeSize = (indexId) => {
    let data = JSON.parse(JSON.stringify(customizationData));
    let defaultStatus = data[props.orderSelected].sizes.map((item, index) => {
      if (index === indexId) {
        let updateCartData = JSON.parse(JSON.stringify(cartData));

        updateCartData.order_items[0].size = item;
        updateCartData.order_items[0].finalPrice =
          item.price + updateCartData.order_items[0].allAddonsTotal;
        setCardData(updateCartData);
        return { ...item, isDefault: true };
      } else {
        return { ...item, isDefault: false };
      }
    });

    data[props.orderSelected].sizes = defaultStatus;
    console.log('data', data)
    setCustomizationData(data);
  };

  const [showPersonalization, setShowPersonalization] = useState(false);
  const [spiceLevel, setShowSpiceLevel] = useState({ status: false, level: 1 });
  const [saltLevel, setShowSaltLevel] = useState(false);
  const [sugarLevel, setShowSugarLevel] = useState(false);
  const [fatLevel, setShowFatLevel] = useState(false);
  const [eggLevel, setShowEggLevel] = useState(false);
  const [meatLevel, setShowMeatLevel] = useState(false);

  const onChangeAddOn = (optionsData, addOnId, optionsId, checkedStatus) => {
    // changes checked status
    let actualStateData = JSON.parse(JSON.stringify(customizationData));
    let updatedChecked = [];

    for (let i = 0; i < actualStateData.addOns.length; i++) {
      if (actualStateData.addOns[i]._id === addOnId) {
        let tempAddOn = {};
        tempAddOn = JSON.parse(JSON.stringify(actualStateData.addOns[i]));
        tempAddOn.options = [];
        for (let j = 0; j < actualStateData.addOns[i].options.length; j++) {
          if (actualStateData.addOns[i].options[j]._id === optionsId) {
            let tempChecked = actualStateData.addOns[i].options[j];
            if (checkedStatus === undefined) {
              tempChecked.checked = true;
              tempAddOn.options.push(tempChecked);
            } else if (checkedStatus) {
              tempChecked.checked = false;
              tempAddOn.options.push(tempChecked);
            } else {
              tempChecked.checked = true;
              tempAddOn.options.push(tempChecked);
            }
          } else {
            tempAddOn.options.push(actualStateData.addOns[i].options[j]);
          }
        }
        updatedChecked.push(tempAddOn);
      } else {
        updatedChecked.push(actualStateData.addOns[i]);
      }
    }

    actualStateData.addOns = updatedChecked;
    console.log('actualStateData', actualStateData)
    setCustomizationData(actualStateData);

    let checkStatus = document.getElementById(optionsId).checked;
    let actualData = JSON.parse(JSON.stringify(cartData));

    let foundAddOnId = false;

    for (let i = 0; i < cartData.order_items[0].addOns.length; i++) {
      if (addOnId === cartData.order_items[0].addOns[i]._id) {
        foundAddOnId = true;
        if (checkStatus) {
          let data = cartData.order_items[0].addOns[i];
          data.options.push(optionsData);
          actualData.order_items[0].addOns[i] = data;
          actualData.order_items[0].finalPrice =
            actualData.order_items[0].finalPrice + parseInt(optionsData.price);
          actualData.order_items[0].allAddonsTotal =
            actualData.order_items[0].allAddonsTotal +
            parseInt(optionsData.price);
        } else {
          let removeAddon = actualData.order_items[0].addOns[i].options.filter(
            (item) => {
              return optionsId !== item._id;
            }
          );
          if (removeAddon.length === 0) {
            //actualData.order_items[0].addOns[i].options = removeAddon;

            actualData.order_items[0].addOns.splice(i, 1);
          } else {
            actualData.order_items[0].addOns[i].options = removeAddon;
          }
          actualData.order_items[0].finalPrice =
            actualData.order_items[0].finalPrice - parseInt(optionsData.price);
          actualData.order_items[0].allAddonsTotal =
            actualData.order_items[0].allAddonsTotal -
            parseInt(optionsData.price);
        }
      }
    }

    if (!foundAddOnId) {
      let data = {};
      data._id = addOnId;
      data.options = [];
      data.options.push(optionsData);
      actualData.order_items[0].finalPrice =
        actualData.order_items[0].finalPrice + parseInt(optionsData.price);
      actualData.order_items[0].allAddonsTotal =
        actualData.order_items[0].allAddonsTotal + parseInt(optionsData.price);
      actualData.order_items[0].addOns.push(data);
    }

    setCardData(actualData);
  };

  const onChangeLevel = (e, value, type) => {
    if (type === "spice_level") {
      setShowSpiceLevel({
        ...spiceLevel,
        level: value,
      });
    } else if (type === "salt_level") {
      setShowSaltLevel({
        ...saltLevel,
        level: value,
      });
    } else if (type === "sugar_level") {
      setShowSugarLevel({
        ...sugarLevel,
        level: value,
      });
    } else if (type === "fat_level") {
      setShowFatLevel({
        ...fatLevel,
        level: value,
      });
    } else if (type === "meat_cook_level") {
      setShowMeatLevel({
        ...meatLevel,
        level: value,
      });
    } else if (type === "egg_cook_level") {
      setShowEggLevel({
        ...eggLevel,
        level: value,
      });
    }

    let actualData = JSON.parse(JSON.stringify(cartData));

    actualData.order_items[0].customised_details[type] = { level: value };

    setCardData(actualData);
  };

  const onChangeAddNote = (e) => {
    let actualData = JSON.parse(JSON.stringify(cartData));
    actualData.order_items[0].notes = e.target.value;
    setCardData(actualData);
  };

  const addItemToCart = () => {
    let actualCartData = JSON.parse(JSON.stringify(cartData));
    actualCartData.order_items[0].itemId = props.customizationData._id;
    actualCartData.order_items[0].customised =
      props.customizationData.customizable !== undefined &&
        props.customizationData.customizable !== null
        ? props.customizationData.customizable
        : false;
    let actualTotal = cartData.order_items[0].finalPrice;
    let charges = 0;

    for (let i = 0; i < cartData.order_items[0].sur_charges.length; i++) {
      if (cartData.order_items[0].sur_charges[i].flag === "VALUE") {
        charges =
          charges + parseFloat(cartData.order_items[0].sur_charges[i].value);
      } else {
        let percent =
          (actualTotal *
            parseFloat(cartData.order_items[0].sur_charges[i].value)) /
          100;
        charges = charges + percent;
      }
    }
    actualCartData.order_items[0].charges = charges;
    // let cartQuantity = 1;

    let count = 0;

    let exisTingData = [...props.cart_data];

    for (let i = 0; i < exisTingData.length; i++) {
      if (exisTingData[i][0].size._id === cartData.order_items[0].size._id) {
        count = count + exisTingData[i][0].quantity;
        //props.incrementHandler(cartQuantity);
      }
    }

    // if (count > 0) {
    //   props.onClickContinue(cartQuantity + count);
    // } else {
    //   props.onClickContinue(cartQuantity);
    // }

    props.closeCustom2();
    props.incrementHandlerForRepeatedSize();

    dispatch({
      type: SET_VENDOR_ORDERING_CART_DATA,
      payload: actualCartData,
    });
  };

  const onChangeInCaseOf = (e) => {
    let exisTingData = JSON.parse(JSON.stringify(cartData));
    exisTingData.order_items[0].incase_of_unavailable = e.target.value;

    setCardData(exisTingData);
  };

  useEffect(() => {
    setCustomizationData(props.customizationData);

    let prepareCartData = {
      order_items: [
        {
          item: {},
          size: {},
          customised_details: {},
          customised: false,
          quantity: 1,
          addOns: [],
          finalPrice: 0,
          allAddonsTotal: 0,
          notes: "",
          incase_of_unavailable: "",
          // veg: false,
          sur_charges: [],
          charges: 0,
          counter_number: "",
        },
      ],
    };

    prepareCartData.order_items[0].item.images = props?.customizationData?.images || '';
    prepareCartData.order_items[0].item.prepTime = props?.customizationData?.prepTime;
    prepareCartData.order_items[0].item.counter_number = props?.customizationData?.counter_number;
    prepareCartData.order_items[0].item.auto_accept = props?.customizationData?.auto_accept;
    prepareCartData.order_items[0].item.veg = props?.customizationData?.veg;
    prepareCartData.order_items[0].item.itemType = props?.customizationData?.itemType;
    prepareCartData.order_items[0].item.name = props?.customizationData?.name;
    prepareCartData.order_items[0].item.category = props?.customizationData?.category;
    prepareCartData.order_items[0].item.description = props?.customizationData?.description;
    prepareCartData.order_items[0].item.ingredient_description = props?.customizationData?.ingredient_description;
    prepareCartData.order_items[0].item.keywords = props?.customizationData?.keywords;
    prepareCartData.order_items[0].item.id = props?.customizationData?._id;
    prepareCartData.order_items[0].veg = props?.customizationData?.veg;
    prepareCartData.order_items[0].itemType = props?.customizationData?.itemType;
    prepareCartData.order_items[0].sur_charges = props?.customizationData?.[props.orderSelected]?.sur_charges || [];

    if (props?.customizationData?.[props.orderSelected]?.sizes) {
      for (
        let i = 0;
        i < props.customizationData[props.orderSelected].sizes.length;
        i++
      ) {
        if (props.customizationData[props.orderSelected].sizes[i].isDefault) {
          prepareCartData.order_items[0].finalPrice =
            props.customizationData[props.orderSelected].sizes[i].price;
          prepareCartData.order_items[0].size =
            props.customizationData[props.orderSelected].sizes[i];
        }
      }
    }

    if (
      props.customizationData &&
      props.customizationData.personalization_status
    ) {
      setShowPersonalization(true);
      prepareCartData.order_items[0].customised_details.customised = true;

      if (props.customizationData.spice_level.value) {
        setShowSpiceLevel({
          status: true,
          level: props.customizationData.spice_level.level,
        });

        prepareCartData.order_items[0].customised_details.spice_level = {};
        prepareCartData.order_items[0].customised_details.spice_level = {
          level: props.customizationData.spice_level.level,
        };
      }
      if (props.customizationData.salt_level.value) {
        setShowSaltLevel({
          status: true,
          level: props.customizationData.salt_level.level,
        });
        prepareCartData.order_items[0].customised_details.salt_level = {};
        prepareCartData.order_items[0].customised_details.salt_level = {
          level: props.customizationData.salt_level.level,
        };
      }
      if (props.customizationData.sugar_level.value) {
        setShowSugarLevel({
          status: true,
          level: props.customizationData.sugar_level.level,
        });
        prepareCartData.order_items[0].customised_details.sugar_level = {};
        prepareCartData.order_items[0].customised_details.sugar_level = {
          level: props.customizationData.sugar_level.level,
        };
      }
      if (props.customizationData.fat_level.value) {
        setShowFatLevel({
          status: true,
          level: props.customizationData.fat_level.level,
        });
        prepareCartData.order_items[0].customised_details.fat_level = {};
        prepareCartData.order_items[0].customised_details.fat_level = {
          level: props.customizationData.fat_level.level,
        };
      }
      if (props.customizationData.meat_cook_level.value) {
        setShowMeatLevel({
          status: true,
          level: props.customizationData.meat_cook_level.level,
        });
        prepareCartData.order_items[0].customised_details.meat_cook_level = {};
        prepareCartData.order_items[0].customised_details.meat_cook_level = {
          level: props.customizationData.meat_cook_level.level,
        };
      }
      if (props.customizationData.egg_cook_level.value) {
        setShowEggLevel({
          status: true,
          level: props.customizationData.egg_cook_level.level,
        });
        prepareCartData.order_items[0].customised_details.egg_cook_level = {};
        prepareCartData.order_items[0].customised_details.egg_cook_level = {
          level: props.customizationData.egg_cook_level.level,
        };
      }
    }
    setCardData(prepareCartData);
  }, [props.customizationData]);

  return (
    <React.Fragment>
      <Container fluid>
        <div>
          {/* <Button
              size="large"
              className="btn btn-danger btn-lg"
              style={{ color: "white" }}
              onClick={() => {
                setOpen(true);
                // props.updateCart();
              }}
            >
              Add&nbsp;&nbsp;
              <span style={{ fontSize: ".75rem" }}>Customize</span>
            </Button> */}
          <Modal
            show={props.open}
            size="md"
            onHide={props.closeCustom2}
            centered
          >
            <Modal.Header className="border-0" closeButton>
              <Modal.Title className="f24_700_HelveticaNeue">
                {value === 0 ? "Customization" : "Personalization"}
              </Modal.Title>
            </Modal.Header>
            <hr />
            <Modal.Body>
              <div className="row " style={{ backgroundColor: "#FFFBEE" }}>
                <Col md={2}>
                  <img
                    src={
                      (customizationData &&
                        customizationData.images &&
                        customizationData.images[0]) ||
                      DEFAULT_ITEM_IMAGE
                    }
                    width="60px"
                    alt={customizationData && customizationData?.name}
                    title={customizationData && customizationData?.name}
                  />
                </Col>
                <Col md={10}>
                  <div className="f16-500">
                    {ITEMTYPEVEG.map((type, index) => {
                      return (
                        <React.Fragment key={index}>
                          {customizationData?.itemType === type?.value ? (
                            <Image
                              width="15px"
                              height="15px"
                              src={type.url}
                              alt={type.title}
                              title={type.title}
                              fluid
                            />
                          ) : null}
                        </React.Fragment>
                      );
                    })}{" "}
                    {/* <img
                      src={
                        customizationData.veg
                          ? require("../../../../assets/images/superadmin/ordericon/veg.svg")
                          : require("../../../../assets/images/superadmin/ordericon/non veg.svg")
                      }
                      width="15px"
                      heigth="15px"
                    /> */}
                    &nbsp;&nbsp;
                    {customizationData.name}
                  </div>
                  <div
                    style={{
                      position: "relative",
                      paddingLeft: "10px",
                      paddingRight: "10px",
                      top: "2%",
                      left: "5%",
                    }}
                    className="badge badge-dark bottom-left"
                  >
                    <img
                      src={require("../../../../assets/images/superadmin/ordericon/star.svg")}
                      width="10px"
                      heigth="10px"
                      alt="Star"
                    />
                    {/* 4.2 550 reviews */}
                    {
                      // props &&
                      // props.customizationData &&
                      // props.customizationData.review_rated === false
                      //   ? "0"
                      //   :
                      props.customizationData.rating
                    }
                  </div>
                </Col>
              </div>
              <div
                classname="row "
                style={{
                  backgroundColor: "#F3F3F3",
                  marginTop: "2%",
                  width: "100%",
                  padding: "5px 15px 5px 15px",
                }}
              >
                {customizationData.description}
              </div>
              <Container fluid className="add-customization-order-processing">
                <div style={{ padding: "10px" }}>
                  {props?.customizationData?.customizable ? (
                    <span
                      style={{
                        color: value === 0 ? "#EE3A23" : "#BDBDBD",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        setValue(0);
                      }}
                    >
                      Customization
                    </span>
                  ) : null}
                  &nbsp;&nbsp;
                  {props?.customizationData?.personalization_status ? (
                    <span
                      style={{
                        color: value === 1 ? "#EE3A23" : "#BDBDBD",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        setValue(1);
                      }}
                    >
                      Personalization
                    </span>
                  ) : null}
                  <br />
                  {props?.customizationData?.customizable ||
                    props?.customizationData?.personalization_status ? (
                    <div>
                      {value === 0 ? (
                        <div
                          style={{
                            width: "100px",
                            height: "5px",
                            backgroundColor: "#EE3A23",
                          }}
                        ></div>
                      ) : (
                        <div
                          style={{
                            width: "100px",
                            height: "5px",
                            backgroundColor: "#EE3A23",
                            marginLeft: "110px",
                          }}
                        ></div>
                      )}
                    </div>
                  ) : null}
                </div>
                <div>
                  {value === 0 && (
                    <div style={{ marginTop: "3%" }}>
                      <h5>Size</h5>
                      <p>Please select your {props.categoryName} 's size</p>
                      <Row>
                        <Col md={12}>
                          <FormControl
                            component="fieldset"
                            style={{ width: "100%" }}
                          >
                            <RadioGroup aria-label="Size" name="Size">
                              {customizationData?.[
                                  props.orderSelected
                                ]?.sizes?.map((item, index) => (
                                  <Row key={index}>
                                    <Col xs={8}>
                                      <FormControlLabel
                                        // /value={item.description}
                                        control={<Radio />}
                                        label={item.description}
                                        checked={item.isDefault}
                                        onChange={() => onChangeSize(index)}
                                      />
                                    </Col>
                                    <Col
                                      xs={4}
                                      align="right"
                                      className="f14-400"
                                    >
                                      ₹ {item.price}
                                    </Col>
                                  </Row>
                                ))}
                            </RadioGroup>
                          </FormControl>
                        </Col>
                      </Row>
                      <hr />
                      {/* <h5>Base</h5>
                      <p>Please select your pizza's base</p>
                      <Row>
                        <Col md={8}>
                          <FormControl component="fieldset">
                            <RadioGroup
                              aria-label="Base"
                              name="Base"
                              // value={value}
                              // onChange={handleChange}
                            >
                              <FormControlLabel
                                value="Hand Tossed"
                                control={<Radio />}
                                label="Hand Tossed"
                              />
                              <FormControlLabel
                                value="Thin Crust"
                                control={<Radio />}
                                label="Thin Crust"
                              />
                              <FormControlLabel
                                value="Double Decker"
                                control={<Radio />}
                                label="Double Decker"
                              />
                            </RadioGroup>
                          </FormControl>
                        </Col>
                        <Col md={4} align="right">
                          <b>
                            ₹ 25
                            <br />
                            ₹ 45
                            <br />₹ 100
                          </b>
                        </Col>
                      </Row>
                      <hr /> */}
                      {props?.customizationData?.customizable ? (
                        customizationData &&
                          customizationData.addOns &&
                          customizationData.addOns.length > 0 ? (
                          <>
                            <h5>Add Ons</h5>
                            <hr />
                          </>
                        ) : (
                          <> </>
                        )
                      ) : null}
                      {/* <p>Please select toppings maximum upto 5</p>
                      
                      <Row>
                        <Col md={8}>
                          <table style={{ width: "100%" }}>
                            <tbody>
                              <tr>
                                <td style={{ width: "25px" }}>
                                  <input type="checkbox" />
                                </td>
                                <td></td>
                              </tr>
                              <tr>
                                <td style={{ width: "25px" }}>
                                  <input type="checkbox" />
                                </td>
                                <td>Onions</td>
                              </tr>
                              <tr>
                                <td style={{ width: "25px" }}>
                                  <input type="checkbox" />
                                </td>
                                <td>Tomatoes</td>
                              </tr>
                              <tr>
                                <td style={{ width: "25px" }}>
                                  <input type="checkbox" />
                                </td>
                                <td>Capsicum</td>
                              </tr>
                              <tr>
                                <td style={{ width: "25px" }}>
                                  <input type="checkbox" />
                                </td>
                                <td>Jalapenos</td>
                              </tr>
                              <tr>
                                <td style={{ width: "25px" }}>
                                  <input type="checkbox" />
                                </td>
                                <td>Pineapple</td>
                              </tr>
                              <tr>
                                <td style={{ width: "25px" }}>
                                  <input type="checkbox" />
                                </td>
                                <td>Sweets Corns</td>
                              </tr>
                              <tr>
                                <td style={{ width: "25px" }}>
                                  <input type="checkbox" />
                                </td>
                                <td>Paneer</td>
                              </tr>
                            </tbody>
                          </table>
                        </Col>
                        <Col md={4} align="right">
                          <b>
                            ₹ 25
                            <br />
                            ₹ 45
                            <br />
                            ₹ 45
                            <br />
                            ₹ 45
                            <br />
                            ₹ 45
                            <br />
                            ₹ 45
                            <br />
                            ₹ 45
                            <br />₹ 45
                          </b>
                        </Col>
                      </Row> */}

                      {props?.customizationData?.customizable
                        ? customizationData &&
                        customizationData.addOns &&
                        customizationData.addOns.map((item, index) => (
                          <Fragment key={index}>
                            <h5>{item.name}</h5>
                            {/* <Row> */}
                            {item.options.map((data, index) => (
                              <Fragment key={index}>
                                <div className="d-flex mb-2 align-items-middle justify-content-between">
                                  <div>
                                    <input
                                      id={data._id}
                                      checked={data.checked}
                                      type="checkbox"
                                      className="mr-3"
                                      onChange={() =>
                                        onChangeAddOn(
                                          data,
                                          item._id,
                                          data._id,
                                          data.checked
                                        )
                                      }
                                    />
                                    {data.name}
                                  </div>
                                  <div className="f14-500">
                                    ₹ {data.price}
                                  </div>
                                </div>
                              </Fragment>
                            ))}
                            {/* </Row> */}
                          </Fragment>
                        ))
                        : null}
                    </div>
                  )}

                  {value === 1 && (
                    <div>
                      <h5>Personalization</h5>
                      <br />
                      {spiceLevel.status ? (
                        <>
                          <h5>Spice Level</h5>
                          <br />
                          <div>
                            <Col xl={12}>
                              <div className="w-100 mb-4 spice">
                                <Slider
                                  min={0}
                                  max={4}
                                  name="spice_level.level"
                                  //defaultValue={0}
                                  value={spiceLevel.level}
                                  step={1}
                                  // onChange={(e, value) =>
                                  //   setShowSpiceLevel({
                                  //     ...spiceLevel,
                                  //     level: value,
                                  //   })
                                  // }
                                  onChange={(e, value) =>
                                    onChangeLevel(e, value, "spice_level")
                                  }
                                  disabled={
                                    !props?.customizationData?.spice_level
                                      ?.customized
                                  }
                                />
                                <div className="d-flex justify-content-between align-items-center">
                                  <div className="f10-400">No Spice</div>
                                  <div className="f10-400">Mild</div>
                                  <div className="f10-400">Medium</div>
                                  <div className="f10-400">Hot</div>
                                  <div className="f10-400">Very Hot</div>
                                </div>
                              </div>
                            </Col>
                          </div>
                        </>
                      ) : (
                        <> </>
                      )}

                      {saltLevel.status ? (
                        <>
                          <h5>Salt Level</h5>
                          <br />
                          <div>
                            <Col xl={12}>
                              <div className="w-100 mb-4 spice">
                                <Slider
                                  min={0}
                                  max={5}
                                  name="salt_level.level"
                                  value={saltLevel.level}
                                  step={1}
                                  // onChange={(e, value) =>
                                  //   setShowSaltLevel({
                                  //     ...saltLevel,
                                  //     level: value,
                                  //   })
                                  // }
                                  onChange={(e, value) =>
                                    onChangeLevel(e, value, "salt_level")
                                  }
                                  disabled={
                                    !props?.customizationData?.salt_level
                                      ?.customized
                                  }
                                />
                                <div className="d-flex justify-content-between align-items-center">
                                  <div className="f10-400">No Salt</div>
                                  <div className="f10-400">Low</div>
                                  <div className="f10-400">Normal</div>
                                  <div className="f10-400">Medium</div>
                                  <div className="f10-400">Salty</div>
                                  <div className="f10-400">Very Salty</div>
                                </div>
                              </div>
                            </Col>
                          </div>
                        </>
                      ) : (
                        <> </>
                      )}

                      {sugarLevel.status ? (
                        <>
                          <h5>Sugar Level</h5>
                          <br />
                          <div>
                            <Col xl={12}>
                              <div className="w-100 mb-4 suger">
                                <Slider
                                  min={0}
                                  max={5}
                                  name="salt_level.level"
                                  value={sugarLevel.level}
                                  step={1}
                                  // onChange={(e, value) =>
                                  //   setShowSugarLevel({
                                  //     ...sugarLevel,
                                  //     level: value,
                                  //   })
                                  // }
                                  onChange={(e, value) =>
                                    onChangeLevel(e, value, "sugar_level")
                                  }
                                  disabled={
                                    !props?.customizationData?.sugar_level
                                      ?.customized
                                  }
                                />
                                <div className="d-flex justify-content-between align-items-center">
                                  <div className="f10-400">No Sugar</div>
                                  <div className="f10-400">Low</div>
                                  <div className="f10-400">Normal</div>
                                  <div className="f10-400">Medium</div>
                                  <div className="f10-400">Sweet</div>
                                  <div className="f10-400">Very Sweet</div>
                                </div>
                              </div>
                            </Col>
                          </div>
                        </>
                      ) : (
                        <> </>
                      )}

                      {fatLevel.status ? (
                        <>
                          <h5>Fat/Oil/Fried Cook Level</h5>
                          <br />
                          <div>
                            <Col xl={12}>
                              <div className="w-100 mb-4 fat">
                                <Slider
                                  min={0}
                                  max={5}
                                  name="salt_level.level"
                                  value={fatLevel.level}
                                  step={1}
                                  // onChange={(e, value) =>
                                  //   setShowFatLevel({
                                  //     ...fatLevel,
                                  //     level: value,
                                  //   })
                                  // }
                                  onChange={(e, value) =>
                                    onChangeLevel(e, value, "fat_level")
                                  }
                                  disabled={
                                    !props?.customizationData?.fat_level
                                      ?.customized
                                  }
                                />
                                <div className="d-flex justify-content-between align-items-center">
                                  <div className="f10-400">No Oil</div>
                                  <div className="f10-400">Low</div>
                                  <div className="f10-400">Normal</div>
                                  <div className="f10-400">Medium</div>
                                  <div className="f10-400">Regular</div>
                                  <div className="f10-400">Extra</div>
                                </div>
                              </div>
                            </Col>
                          </div>
                        </>
                      ) : (
                        <> </>
                      )}

                      {meatLevel.status ? (
                        <>
                          <h5>Meat Cook Level</h5>
                          <br />
                          <div>
                            <Col xl={12}>
                              <div className="w-100 mb-4 meat">
                                <Slider
                                  min={0}
                                  max={5}
                                  name="salt_level.level"
                                  value={meatLevel.level}
                                  step={1}
                                  // onChange={(e, value) =>
                                  //   setShowMeatLevel({
                                  //     ...meatLevel,
                                  //     level: value,
                                  //   })
                                  // }
                                  onChange={(e, value) =>
                                    onChangeLevel(e, value, "meat_cook_level")
                                  }
                                  disabled={
                                    !props?.customizationData?.meat_cook_level
                                      ?.customized
                                  }
                                />
                                <div className="d-flex justify-content-between align-items-center">
                                  <div className="f10-400">Raw</div>
                                  <div className="f10-400">Rare</div>
                                  <div className="f10-400">Medium Rare</div>
                                  <div className="f10-400">Medium</div>
                                  <div className="f10-400">Regular</div>
                                  <div className="f10-400">Well Done</div>
                                </div>
                              </div>
                            </Col>
                          </div>
                        </>
                      ) : (
                        <> </>
                      )}

                      {eggLevel.status ? (
                        <>
                          <h5>Egg Cook Level</h5>
                          <br />
                          <div>
                            <Col xl={12}>
                              <div className="w-100 mb-4 egg">
                                <Slider
                                  min={0}
                                  max={5}
                                  name="salt_level.level"
                                  value={eggLevel.level}
                                  step={1}
                                  // onChange={(e, value) =>
                                  //   setShowEggLevel({
                                  //     ...eggLevel,
                                  //     level: value,
                                  //   })
                                  // }
                                  onChange={(e, value) =>
                                    onChangeLevel(e, value, "egg_cook_level")
                                  }
                                  disabled={
                                    !props?.customizationData?.egg_cook_level
                                      ?.customized
                                  }
                                />
                                <div className="d-flex justify-content-between align-items-center">
                                  <div className="f10-400">Raw</div>
                                  <div className="f10-400">Boiled</div>
                                  <div className="f10-400">Sunny Side Up</div>
                                  <div className="f10-400">Scrambled</div>
                                  <div className="f10-400">Omelette</div>
                                  <div className="f10-400">Well Done</div>
                                </div>
                              </div>
                            </Col>
                          </div>
                        </>
                      ) : (
                        <> </>
                      )}
                      {/* <h5>
                        <b>Incase of Unavailability</b>
                      </h5>
                      <br />
                      <select
                        className="form-control"
                        defaultValue="0"
                        value={cartData.order_items[0].incase_of_unavailable}
                        onChange={(e) => onChangeInCaseOf(e)}
                      >
                        <option value="0">Contact Me</option>
                        <option value="1">Substitute Item</option>
                        <option value="2">Cancel and refund money</option>
                      </select>
                      <hr />
                      <h5>
                        <b>Add Note</b>
                      </h5>
                      <br />
                      <textarea
                        className="form-control"
                        placeholder="Any special instructions"
                        onChange={(e) => onChangeAddNote(e)}
                      ></textarea>
                      <hr /> */}
                    </div>
                  )}
                  <Row>
                    <Col md={4}>
                      <b>
                        Total Cost <br />₹{" "}
                        {cartData &&
                          cartData.order_items &&
                          cartData.order_items[0] &&
                          cartData.order_items[0].finalPrice}
                      </b>
                    </Col>
                    <Col md={8}>
                      <button
                        type="button"
                        // onClick={() => {
                        //   props.incrementHandler();
                        //   onCloseModal();
                        // }}
                        onClick={() => addItemToCart()}
                        className="btn btn-danger btn-lg btn btn-primary btn-large w-100"
                        style={{ color: "white" }}
                      >
                        Continue
                      </button>
                    </Col>
                  </Row>
                </div>
              </Container>
            </Modal.Body>
          </Modal>
        </div>
      </Container>
    </React.Fragment>
  );
};
const mapStateToProps = (state) => ({
  auth: state.auth,
  cart_data: state.vendorOrdering.vendor_cart_data,
});

export default connect(mapStateToProps, null)(CustomizationTwo);
